<template>
    <ModelYMD
        :label="label"
        :ymd='ymd'
        @change="emit"
        :valid="valid"
        :year-input-type="yearInputType"
        :max-year="maxYear"
        :min-year="minYear"
        :validator="validator"
        :show-errors="showErrors"
        :disableInputs="disable"
        :hidden-lenght-counter="hiddenLenghtCounter"
    />
</template>

<script>
import ModelYMD from '../../UI/models/ModelYMD';

export default {
    name: 'ModelISO',
    components: {
        ModelYMD,
    },
    data: ()=>({
        ymd: null,
    }),
    watch: {
        value(val) {
            this.ymd = this.isoToYmd(val);
        },
    },
    methods: {
        emit(e){
            this.$emit('change', this.ymdToIso(e));
        },
        isoToYmd(iso) {
            let pIso = this.parseIso(iso);
            return parseInt(`${pIso.year}${pIso.month}${pIso.day}`);
        },
        ymdToIso(ymd) {
            let pYmd = this.parseYmd(ymd);
            return `${pYmd.year}-${pYmd.month}-${pYmd.day}`;
        },
        parseYmd (ymd) {
            ymd = String(ymd);
            return {
                year: ymd.slice(-8, -4),
                month: ymd.slice(-4, -2),
                day: ymd.slice(-2),
            };
        },
        parseIso (iso) {
            iso = String(iso);
            return {
                year: iso.slice(0, 4),
                month: iso.slice(5, 7),
                day: iso.slice(8, 10),
            };
        },
    },
    mounted() {
        this.ymd = this.isoToYmd(this.value);
    },
    props: {
        label: String,
        disable: Boolean,
        value: [String, Number],
        valid: {
            type: Boolean,
            default: true,
        },
        yearInputType: {
            type: String,
            default: 'input',
        },
        minYear: {
            type: Number,
        },
        maxYear: {
            type: Number,
        },
        validator:{
            type: Function,
            default: null,
        },
        showErrors: {
            type: Boolean,
            default: true,
        },
        hiddenLenghtCounter: {
            type: Boolean,
            default: false,
        },
    },
    model: {
        prop: 'value',
        event: 'change',
    },
};
</script>

<style scoped>

</style>